package com.solevo.dist.application.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
enum class NotificationStatus {
    New,
    Read,
    Deleted
}

@Serializable
enum class NotificationType {
    Order,
    Invoice,
    Quote,
    Promotion,
    Message,
    Delivery,
    LoyaltyTransaction
}

@Serializable
enum class MessageType {
    Marketing,
    Transaction
}

data class Notification(
    val notificationId: String? = null,
    val title: String? = null,
    val subtitle: String? = null,
    val message: String? = null,
    val messageType: MessageType? = null,
    val contactId: String? = null,
    val legalEntityId: String? = null,
    val requestId: String? = null,
    val status: NotificationStatus? = NotificationStatus.New,
    val timestamp: Instant? = Clock.System.now(),
    val classification: NotificationType? = null,
    val image: String? = null,
)

data class ChangeStatusRequest(
    val notificationKey: NotificationKey? = null,
    val newStatus: String
)
data class NotificationKey(val notificationId: String? = null)